import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { Segment, VerificationService, VerificationStep } from "../../lib/types/types";
import { FaqLinkComponent } from "../FaqLink/FaqLinkComponent";
import { assertValidSegmentName } from "../../lib/types/assertions";
import { VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { howDoesVerifyingWorkMessages } from "./HowDoesVerifyingWorkMessages";
import { getSafe } from "../../lib/utils/getSafe";
import { Popover } from "../Popover/PopOver";

interface HowDoesVerifyingWorkProps {
  verificationService: VerificationService;
  initialVisibility?: boolean;
}

const getDefaultDetailsMessage = (step: VerificationStep, segment: Segment): string => {
  const messageType = step === VerificationStepsEnum.docUpload ? "docUpload" : "default";
  const defaultMessages = howDoesVerifyingWorkMessages();
  assertValidSegmentName(segment);
  const message = getSafe(() => defaultMessages[segment][messageType], "-");
  return message;
};

const HowDoesVerifyingWorkComponent: React.FC<HowDoesVerifyingWorkProps> = ({
  verificationService,
  initialVisibility = false,
}: HowDoesVerifyingWorkProps) => {
  const { segment } = verificationService.verificationResponse;
  const step = verificationService.verificationResponse.currentStep;
  const defaultMessage = `${getDefaultDetailsMessage(step, segment)}`;

  return (
    <Popover
      initialVisibility={initialVisibility}
      trigger={
        <button
          type="button"
          className="sid-h-btn-link-like sid-link sid-how-does-verifying-work-hoverable"
        >
          <FormattedHTMLMessage
            id="howDoesVerifyingWork"
            defaultMessage="How does verifying work?"
          />
        </button>
      }
      message={
        <div>
          <FormattedHTMLMessage id="companyName" defaultMessage="{Company}">
            {(companyName) => (
              <FormattedHTMLMessage
                id="step.personalInfo.howDoesVerifyingWorkDetails"
                defaultMessage={defaultMessage}
                values={{ companyName }}
              />
            )}
          </FormattedHTMLMessage>
          &nbsp;
          <FaqLinkComponent verificationService={verificationService} />
        </div>
      }
    />
  );
};

export { HowDoesVerifyingWorkComponent };
